jQuery(document).ready(function ($) {

    $("input[name=\"certificates\"]").on("change input", function () {
        const singleCertificatePrice = certificatesSettings.singleCertificatePrice,
            certificates = $(this).val() < certificatesSettings.minimumAmountOfCertificates ? certificatesSettings.minimumAmountOfCertificates : parseFloat($(this).val()),
            amount = singleCertificatePrice * certificates;

        $("input[name=\"amount\"]").val(amount);

        update_selection(certificates, amount);
    });

    $("input[name=\"amount\"]").on("change input", function () {
        const singleCertificatePrice = certificatesSettings.singleCertificatePrice,
            minimumAmount = certificatesSettings.minimumAmountOfCertificates * certificatesSettings.singleCertificatePrice,
            amount = $(this).val() < minimumAmount ? minimumAmount : parseFloat($(this).val()),
            certificates = parseFloat(amount / singleCertificatePrice);

        if (isNaN(amount)) {
            return false;
        }

        if (certificates % 1 === 0) {
            $("input[name=\"certificates\"]").val(amount / singleCertificatePrice);
            $(".summary .certificates-amount span").text(amount / singleCertificatePrice);
            $(".summary .value").text(moneyFormat(amount));
            update_selection(certificates, amount);
        }

        if (certificates % 1 !== 0) {
            const suggestAmount = Math.ceil(certificates) * certificatesSettings.singleCertificatePrice,
                buttonText = strings.error.button.replace("%d", Math.ceil(certificates)).replace("%s", moneyFormat(suggestAmount)),
                buttonHTML = `
					<button 
						data-certificates="${Math.ceil(certificates)}" 
						data-amount="${suggestAmount}"
					>
						${buttonText}
					</button>
				`;
            error_message(".certificates .flex-form", strings.error.message + buttonHTML);
        } else {
            remove_error_message(".certificates .flex-form");
        }

    });

    $(document).on("click", ".errors button[data-certificates]", function () {

        const amount = $(this).data("amount"),
            certificates = $(this).data("certificates");

        $("input[name=\"amount\"]").val(amount).trigger("input");
        $("input[name=\"certificates\"]").val(certificates).trigger("input");

        return false;
    });

    $("#certificates-form").on("submit", function () {

        const $this = $(this),
            formId = $this.prop("id"),
            formData = getFormData($this),
            submitButtons = $("form#" + formId + " input[type=\"submit\"], input[form=\"" + formId + "\"]");

        formData.append("action", certificatesSettings.action);
        formData.append("nonce", certificatesSettings.nonce);
        formData.append("postId", certificatesSettings.postId);

        if (formData) {
            $.ajaxWithRecaptcha({
                url: certificatesSettings.ajaxUrl,
                method: "POST",
                processData: false,
                contentType: false,
                data: formData,
                beforeSend: function () {
                    $this.addClass("processing");

                    $.each(submitButtons, function (index, button) {
                        $(button).attr("disabled", true).after("<span class=\"spinner\"></span>");
                    });

                    clear_error_messages($this);
                },
                complete: function () {
                    $this.removeClass("processing");

                    $.each(submitButtons, function (index, button) {
                        $(button).next(".spinner").remove();
                        $(button).attr("disabled", false);
                    });
                },
                success: function (response) {
                    if (response.success) {
                        window.location.href = response.data.redirect;
                    }
                },
                error: function (xhr, status, error) {
                    const response = xhr.responseJSON;

                    $.each(response.data.errors, function (key, error) {
                        show_error_messages($this.find("[name=\"" + error.name + "\"]"), error.message);
                    });

                    scrollToIfOutOfView($this);
                },
            });
        }

        return false;

    });

    function update_selection(certificates, amount) {
        let extra = 0,
            text = "";

        $(".summary .certificates-amount span").text(certificates);
        $(".summary .value").text(moneyFormat(amount));

        switch (true) {
            case amount >= certificatesSettings.extra.second.threshold:
                extra = certificates * (certificatesSettings.extra.second.percentage / 100);
                break;
            case amount >= certificatesSettings.extra.first.threshold:
                extra = certificates * (certificatesSettings.extra.first.percentage / 100);
                break;
        }

        if (extra > 0) {
            text = "U krijgt " + extra.toFixed() + " certificaten @ " + moneyFormat(certificatesSettings.singleCertificatePrice) + " extra";
            $(".summary .discount").show().find(".value").text(certificates + parseInt(extra.toFixed()));
        } else {
            $(".summary .discount").hide().find(".value").text(certificates);
        }

        $(".summary .certificates-extra").text(text);
    }

    function error_message(location, message) {
        let errorsElement = $(location).find(".errors");

        if (errorsElement.length === 0) {
            errorsElement = $("<div class=\"errors\"><p></p></div>");
            $(location).append(errorsElement);
        }
        errorsElement.slideDown().find("p").html(message);
    }

    function remove_error_message(location) {
        $(location).find(".errors").remove();
    }

    function moneyFormat(nStr) {
        return "€ " + parseFloat(nStr, 10).toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
    }

    function getFormData(form) {
        let data = new FormData($(form).get(0));

        // Serialize form elements
        $(form).find("input, textarea, select").each(function () {
            if ($(this).is(":disabled")) {
                return;
            }

            if (($(this).is(":radio") || $(this).is(":checkbox")) && !$(this).is(":checked")) {
                return;
            }

            if ($(this).is("select[multiple]") && $(this).find("option:selected").length === 0) {
                return;
            }

            data.append(this.name, this.value);
        });

        // Handle multiple selects
        $(form).find("select[multiple]").each(function () {
            if ($(this).is(":disabled")) {
                return;
            }

            let selectedOptions = [];

            $(this).find("option:selected").each(function () {
                selectedOptions.push($(this).val());
            });

            data.append($(this).attr("name"), selectedOptions);
        });

        return data;
    }


    function show_error_messages($field, message) {
        const $fieldset = $field.closest("fieldset");

        let $errorBox = $fieldset.children(".error-messages");

        if ($errorBox.length === 0) {
            $errorBox = $("<div class=\"error-messages\" />");
            $fieldset.append($errorBox);
        }

        $errorBox.empty().append($("<p />", {text: message}));

        requestAnimationFrame(() => $errorBox.addClass("active"));

        $field.addClass("error");
    }

    function clear_error_messages($form) {
        $form.find(".error").removeClass("error");

        $form.find(".error-messages").each(function () {
            const $box = $(this);
            $box.removeClass("active");
            setTimeout(() => $box.empty(), 300);
        });
    }

    function scrollToIfOutOfView(element) {
        const $el = $(element);

        if (!$el.length){
            return;
        }

        const elTop = $el.offset().top,
            scrollTop = $(window).scrollTop(),
            windowHeight = $(window).height();

        // target position = element top - 1/3 of viewport height
        const target = elTop - Math.floor(windowHeight / 3);

        if (elTop < scrollTop || elTop > scrollTop + windowHeight) {
            $("html, body").animate({ scrollTop: target }, 300);
        }
    }

});